<template>
  <transition
    enter-active-class="ease-out duration-300"
    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
    leave-active-class="ease-in duration-200"
    leave-class="opacity-100 translate-y-0 sm:scale-100"
    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  >
    <base-modal size="small" :open="active" v-on:close="$emit('close')">
      <!-- #region tabs com opção de criar novo conjunto de parâmetros e importar parâmetros à partir de uma hash -->
      <ontick-div class="w-full px-3 py-6">
        <ontick-text
          size="medium"
          weight="medium"
          align="center"
          class="py-3 text-gray-300"
          style="white-space: wrap !important"
          >Você tem certeza que deseja resetar os parâmetros?</ontick-text
        >
      </ontick-div>
      <!-- #endregion -->

      <!-- #region footer -->
      <template slot="footer">
        <ontick-div
          orientation="horizontal"
          class="border-ontick-graphite-600 justify-end border-t p-3"
        >
          <ontick-button
            size="small"
            color="third"
            class="mr-3"
            @click.native="$emit('close')"
            >Cancelar</ontick-button
          >
          <ontick-button size="small" @click.native="$emit('confirm')"
            >Confirmar</ontick-button
          >
        </ontick-div>
      </template>
      <!-- #endregion -->
    </base-modal>
  </transition>
</template>

<script>
import PincodeInput from "vue-pincode-input";

export default {
  name: "save-modal",
  components: {
    BaseModal: () => import("./base-modal.component"),
    PincodeInput,
  },
  props: {
    active: Boolean,
  },
  data() {
    return {
      param: {
        errors: {},
      },
      options: [],
      selected_option: {},
      tab_options: [
        { tag: "novo", name: "Novo" },
        { tag: "importar", name: "Importar" },
      ],
      active_tab: "novo",
      tab_style: {
        all: "flex flex-1 items-center justify-center text-center px-3 py-4 border-b-2 hover:text-white transform transition ease-in-out duration-300 sm:duration-500 transition-all",
        active: "border-ontick-blue-500 text-white font-semibold",
        inactive: "border-ontick-graphite-500 text-gray-400 font-normal",
      },
      //
      code: "",
      styles: {
        button:
          "bg-ontick-third inline-flex items-center px-6 py-3 rounded font-bold text-ontick-light",
        buttonSpan:
          "w-full text-center text-ontick-small text-ontick-white uppercase font-bold",
      },
    };
  },
};
</script>

<style lang="scss" scoped>
// PINCODE COMPONENT
div.vue-pincode-input-wrapper {
  // any styles you want for wrapper
  background-color: #202a37 !important;
  display: flex;
  justify-content: center;
}

input.vue-pincode-input {
  // any styles you want for each cell
  background-color: #171e27 !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06) !important;
  color: white !important;
  font-size: 40px !important;
  font-weight: 600 !important;
  padding: 6px 12px !important;
  max-width: 75px;
  margin: 12px;
  border: 2px solid #171e27;
  transition: all 0.3s ease;
  &:focus {
    border: 2px solid #07a4ff;
  }
}

p {
  white-space: normal !important;
}

::-webkit-input-placeholder {
  /* Edge */
  color: #a0aec036;
}
:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #a0aec036;
}
::placeholder {
  color: #a0aec036;
}
</style>
